import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
  Box,
  Card,
  FormHelperText,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import {
  deleteReturnPaymentById,
  getAllClinicPaymentOfHugeRecord,
  getClinicUsers,
  getNewReturnPayments,
  getSupplier,
  getSupplierReturns,
} from "../../../redux/reducers/clinicSlice";
import {
  createReturnOnBillingItems,
  updateReturnOnBillingItems,
} from "../../../redux/reducers/paymentSlice";
import { AppColors } from "../../../util/AppColors";
import {
  ReturnAdjustList,
  returnTypes,
  rolesForBilling,
} from "../../../util/arrayList";
import { delBtn } from "../../../util/CommonIconStyle";
import { RefundTypes, returnReasons } from "../../../util/dropList";
import {
  getPetShopRecordBasedType,
  getPharmacyRecordBasedType,
  getRefundValues,
  getRefundValuesNew,
  getTaxAndSubTotalAndTotal,
  getTreatmentRecordBasedType,
  removeDuplicateBracketText,
  roundWithSignedDiff,
} from "../../../util/function";
import { tblGrayBack } from "../../../util/object";
import PaymentModeDropdown from "../../CommonComponents/PaymentModeDropdown";

const tblHdrs = [
  // "selected",
  "date",
  "invoice",
  "referenceNo",
  "customer",
  // "returnVal",
  // "refundableTax",
  "returnTotal",
  "retStatus",
];

const supTblHdrs = [
  // "selected",
  "date",
  "invoice",
  "supplier",
  "refundableTax",
  "returnTotal",
  "retStatus",
];

const tblNameExpan = {
  date: "Date",
  invoice: "Invoice",
  customer: "Customer",
  supplier: "Supplier",
  returnVal: "Return Value",
  refundableTax: "Refundable Taxes",
  returnTotal: "Return Total",
  retStatus: "Status",
  referenceNo: "Reference No.",
};
const initCrteValues = { type: null, customer: null, supplier: null };

const Returns = () => {
  const dispatch = useDispatch();
  const contentToPrint = useRef(null);
  const [searchValue, setSearchValue] = useState("");
  const [srchUsrValue, setSrchUsrValue] = useState("");
  const [srchSupValue, setSrchSupValue] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [page, setPage] = useState(0);
  const [activeTab, setActiveTab] = useState("Sales");
  const [createModVsble, setCreateModVsble] = useState(false);
  const [updateModVsble, setUpdateModVsble] = useState(false);
  const [viewModVsble, setViewModVsble] = useState(false);
  const [createValues, setCreateValues] = useState(initCrteValues);
  const [createErrs, setCreateErrs] = useState({});
  const [returnValue, setReturnValue] = useState({});
  const [selectedBill, setSelectedBill] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [listNotValid, setListNotValid] = useState(false);
  const invoices = useSelector((state) => state?.payment?.customerInvoices);
  // const clinicDet = useSelector((state) => state?.clinic?.details);
  const {
    suppliers,
    users,
    supplierReturns,
    returnPayments,
    // clinicStocks,
    hugePayments,
    returnPaymentsNew,
  } = useSelector((state) => state?.clinic);
  // const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const itemSize = 10;
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);
  const defaultUrl = `?filter=credit&type=credit&page=1&itemSize=${itemSize}`;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const {
    clinic: clinicDet,
    vets: clinicVets,
    stocks: clinicStocks,
  } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinic: {}, vets: [], stocks: [] };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return {
        clinic: reqData?.clinic ?? {},
        vets: Array.isArray(reqData?.vets) ? reqData?.vets : [],
        stocks: Array.isArray(reqData?.stocks) ? reqData?.stocks : [],
      };
    } catch {
      return { clinic: {}, vets: [], stocks: [] };
    }
  }, [mandateDataRaw]);

  // useEffect(() => {
  //   dispatch(getClinicVets("?type=all"));
  // }, []);

  useEffect(() => {
    getPayments();
    // if (activeTab === "Sales") getPayments();
    // if (activeTab === "Purchase") {
    //   getSupplierReturnsRecord();
    //   dispatch(getClinicStocks());
    // }
  }, [activeTab]);

  // useEffect(() => {
  //   const reqList = (
  //     activeTab === "Purchase" ? supplierReturns : returnPaymentsNew
  //   )?.data?.map((li) => {
  //     return {
  //       ...li,
  //       selected: false,
  //       date: moment(new Date(li?.updatedDate ?? li?.createdDate)).format(
  //         "DD MMM YYYY",
  //       ),
  //       invoice:
  //         li?.invoiceNumbers ??
  //         li?.treatmentInvoiceNumber ??
  //         li?.petShopInvoiceNumber ??
  //         "-",
  //       customer: li?.userName ?? "",
  //       supplier: li?.supplierName ?? "",
  //       returnVal: li?.returnQuantity ?? 0,
  //       refundableTax: getRefundValues(
  //         (li?.paymentDetails ?? li?.paymentReturnDeatils)?.filter(
  //           (pd) => pd?.returnQuantity > 0,
  //         ),
  //       )?.tax,
  //       returnTotal: getRefundValues(
  //         (li?.paymentDetails ?? li?.paymentReturnDeatils)?.filter(
  //           (pd) => pd?.returnQuantity > 0,
  //         ),
  //       )?.total,
  //       retStatus: li?.creditSave === "credit" ? "Completed" : "Draft",
  //     };
  //   });
  //   setFilteredList(reqList);
  // }, [returnPayments, supplierReturns]);

  useEffect(() => {
    if (
      srchUsrValue?.length > 2 &&
      createValues?.type?.value === "Return on Sales"
    ) {
      dispatch(getClinicUsers(`?search=${srchUsrValue}&itemSize=50&page=1`));
    }
    if (
      srchSupValue?.length > 2 &&
      createValues?.type?.value === "Return on Purchase"
    ) {
      dispatch(getSupplier(`?search=${srchSupValue}&itemSize=50&page=1`));
    }
  }, [srchUsrValue, srchSupValue]);

  const handleDelete = (itm) => {
    setSelectedBill(itm);
    setDelModVsble(true);
  };

  const getTableList = () => {
    const reqList = (returnPaymentsNew?.data ?? [])?.map((li) => {
      const reqNewList =
        activeTab === "Sales"
          ? (li?.paymentDetails ?? li?.paymentReturnDeatils)
              ?.filter((pd) => pd?.returnQuantity > 0)
              ?.map((pl) => ({ ...pl, quantity: pl?.returnQuantity ?? 0 }))
          : (li?.paymentDetails ?? li?.paymentReturnDeatils)
              ?.filter((pd) => pd?.returnQuantity > 0)
              ?.map((li) => {
                return {
                  ...li,
                  price: Number(
                    Number(li?.itemTotal ?? 0) / Number(li?.quantity ?? 0),
                  ),
                };
              });
      const reqTax = getRefundValuesNew(reqNewList)?.tax;
      const reqTotal = getRefundValuesNew(reqNewList)?.total;
      const reqPrice =
        activeTab === "Sales"
          ? li?.price
          : Number(Number(li?.itemTotal ?? 0) / Number(li?.quantity ?? 0));
      return {
        ...li,
        selected: false,
        date: moment(new Date(li?.updatedDate ?? li?.createdDate)).format(
          "DD MMM YYYY",
        ),
        invoice:
          li?.invoiceNumbers ??
          li?.treatmentInvoiceNumber ??
          li?.petShopInvoiceNumber ??
          "-",
        customer: li?.userName ?? "",
        supplier: li?.supplierName ?? "",
        returnVal: li?.returnQuantity ?? 0,
        refundableTax: reqTax,
        returnTotal: reqTotal,
        retStatus: (
          <div className="flex-row-ali-cen">
            {li?.creditSave === "credit" ? (
              <Typography className="green4 grn-bck status-card fs12 font-medium con-fit ph15">
                Completed
              </Typography>
            ) : (
              <Typography className="yellow3 yel-back status-card fs12 font-medium con-fit ph15">
                Draft
              </Typography>
            )}
            {li?.creditSave === "draft" && (
              <div className="cursor ml20" onClick={() => handleDelete(li)}>
                <div className="flex-center">
                  <DeleteOutlineIcon sx={delBtn} />
                </div>
                <Typography className="red3 fs8 txt-semi-bold text-align-center">
                  Delete
                </Typography>
              </div>
            )}
          </div>
        ),
        price: reqPrice,
      };
    });
    return reqList;
  };

  const getPayments = (pge = 1) => {
    setPage(pge);
    const url = `?type=${activeTab === "Sales" ? "sales" : "purchase"}&itemSize=${itemSize}&page=${pge}`;
    dispatch(getNewReturnPayments(url));
  };

  const getSupplierReturnsRecord = () => {
    dispatch(getSupplierReturns(defaultUrl));
    setPage(1);
  };

  const getFilteredSupplierList = () => {
    const reqList = suppliers?.data?.filter((usr) => {
      if (
        usr?.supplierName?.toLowerCase().includes(srchSupValue?.toLowerCase())
      ) {
        return usr;
      }
    });
    return reqList ?? [];
  };

  const getFilteredUserList = () => {
    const reqList = users?.filter((usr) => {
      if (
        usr?.name?.toLowerCase().includes(srchUsrValue?.toLowerCase()) ||
        usr?.email?.toLowerCase().includes(srchUsrValue?.toLowerCase()) ||
        usr?.mobile?.toLowerCase().includes(srchUsrValue?.toLowerCase())
      ) {
        return usr;
      }
    });
    return reqList ?? [];
  };

  const handleChangeCheckBox = (value, ind) => {
    const reqList = filteredList?.map((li, i) => {
      if (i === ind) {
        return { ...li, selected: value };
      }
      return li;
    });
    setFilteredList(reqList);
  };

  const handleCheckAll = () => {
    const reqSel = filteredList?.filter((li) => li?.selected === true);
    const reqList = filteredList?.map((li) => ({
      ...li,
      selected: reqSel?.length > 1 ? false : true,
    }));
    setFilteredList(reqList);
  };

  const handleChangePage = (e, selectedPage) => {
    getPayments(selectedPage);
    // dispatch(
    //   getReturnPayments(
    //     `?filter=credit&type=credit&page=${selectedPage}&itemSize=${itemSize}`,
    //   ),
    // );
    // setPage(selectedPage);
  };

  const handleCloseUpdateMod = () => {
    setUpdateModVsble(false);
    setSelectedBill(null);
    setReturnValue({});
  };

  const handleChange = (name, value) => {
    setReturnValue({ ...returnValue, [name]: value });
  };

  const handleCloseCreateMod = () => {
    setCreateModVsble(false);
    setCreateValues(initCrteValues);
    setCreateErrs({});
  };

  const onChangeCreateValue = (name, value) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    setCreateValues({ ...createValues, [name]: value });
    const errs = {
      ...createErrs,
      [name]:
        (typeof reqValue === "number" ? reqValue?.toString() : reqValue)
          ?.length > 0
          ? ""
          : "This field is required",
    };
    setCreateErrs(errs);
  };

  const handleSelectedUser = (user) => {
    const createObj = {
      ...createValues,
      customer: { name: user?.name, value: user?.id },
    };
    setCreateErrs({ ...createErrs, customer: "" });
    // dispatch(getInvoiceNumbersByCustomerId(`?userId=${user?.id}`));
    setSrchUsrValue("");
    dispatch(
      getAllClinicPaymentOfHugeRecord(
        `?filter=all&type=all&page=1&itemSize=10&userId=${user?.id}`,
      ),
    )?.then((res) => {
      if (res?.payload) {
        const matchedPayment = res?.payload?.data?.find(
          (li) =>
            li?.invoiceNumbers?.length > 0 ||
            li?.treatmentInvoiceNumber?.length > 0 ||
            li?.petShopInvoiceNumber?.length > 0,
        );
        const reqList =
          matchedPayment?.treatmentInvoiceNumber?.length > 0
            ? getTreatmentRecordBasedType(matchedPayment?.paymentDetails)
            : matchedPayment?.invoiceNumbers?.length > 0
              ? getPharmacyRecordBasedType(matchedPayment?.paymentDetails)
              : matchedPayment?.petShopInvoiceNumber?.length > 0
                ? getPetShopRecordBasedType(matchedPayment?.paymentDetails)
                : [];
        const reqAmtData = roundWithSignedDiff(
          getTaxAndSubTotalAndTotal(reqList)?.total,
        );
        const reqInObj = {
          name: `${matchedPayment?.treatmentInvoiceNumber?.length > 0 ? matchedPayment?.treatmentInvoiceNumber : matchedPayment?.invoiceNumbers?.length > 0 ? matchedPayment?.invoiceNumbers : matchedPayment?.petShopInvoiceNumber?.length > 0 ? matchedPayment?.petShopInvoiceNumber : ""}, ₹${reqAmtData?.rounded}, ${moment(new Date(matchedPayment?.createdDate)).format("DD MMM YYYY")}`,
          value:
            matchedPayment?.treatmentInvoiceNumber?.length > 0
              ? matchedPayment?.treatmentInvoiceNumber
              : matchedPayment?.invoiceNumbers?.length > 0
                ? matchedPayment?.invoiceNumbers
                : matchedPayment?.petShopInvoiceNumber?.length > 0
                  ? matchedPayment?.petShopInvoiceNumber
                  : "",
          paymentId: matchedPayment?.paymentId,
        };
        createObj.invoiceNumber = reqInObj;
      }
      setCreateValues(createObj);
    });
  };

  const handleSelectedSupplier = (sup) => {
    setCreateValues({
      ...createValues,
      supplier: { name: sup?.supplierName, value: sup?.supplierId },
    });
    setCreateErrs({ ...createErrs, supplier: "" });
    setSrchSupValue("");
  };

  const getInvoiceList = () => {
    const reqList = (hugePayments?.data ?? [])
      ?.flatMap((li) => [
        li?.invoiceNumbers,
        li?.treatmentInvoiceNumber,
        li?.petShopInvoiceNumber,
      ])
      ?.filter(Boolean);
    return reqList?.map((li) => {
      const reqBill = (hugePayments?.data ?? [])?.find(
        (pl) =>
          pl?.invoiceNumbers === li ||
          pl?.treatmentInvoiceNumber === li ||
          pl?.petShopInvoiceNumber === li,
      );
      const reqList = li?.includes("INVC")
        ? getTreatmentRecordBasedType(reqBill?.paymentDetails)
        : li?.includes("INVP")
          ? getPharmacyRecordBasedType(reqBill?.paymentDetails)
          : li?.includes("INVS")
            ? getPetShopRecordBasedType(reqBill?.paymentDetails)
            : [];
      const reqAmtData = roundWithSignedDiff(
        getTaxAndSubTotalAndTotal(reqList)?.total,
      );
      return {
        name: `${li}, ₹${reqAmtData?.rounded}, ${moment(new Date(reqBill?.createdDate)).format("DD MMM YYYY")}`,
        value: li,
        paymentId: reqBill?.paymentId,
      };
    });
  };

  const getSupInvoiceList = () => {
    if (!createValues?.supplier?.value) return [];
    return (suppliers?.data ?? [])
      ?.find((sup) => sup?.supplierId === createValues?.supplier?.value)
      ?.supplierDetails?.map((det) => {
        const reqList = (det?.subpplierInvoiceDetails ?? [])?.map((sd) => ({
          tax: sd?.taxes ?? 0,
          total: sd?.itemTotal ?? 0,
        }));
        const reqAmtData = roundWithSignedDiff(
          getTaxAndSubTotalAndTotal(reqList)?.total,
        );
        return {
          name: `${det?.invoiceNumber ?? ""}, ₹${reqAmtData?.rounded}, ${moment(new Date(det?.billDate)).format("DD MMM YYYY")}`,
          value: det?.invoiceNumber ?? "",
          detailId: det?.detailId,
          supplierId: createValues?.supplier?.value,
        };
      });
  };

  const handleSubmit = () => {
    let errs = {};
    if (!createValues?.type?.value) {
      errs.type = "This field is required";
    }
    if (
      createValues?.type?.value === "Return on Sales" &&
      !createValues?.customer?.value
    ) {
      errs.customer = "This field is required";
    }
    if (
      createValues?.type?.value === "Return on Purchase" &&
      !createValues?.supplier?.value
    ) {
      errs.supplier = "This field is required";
    }
    if (!createValues?.invoiceNumber?.value) {
      errs.invoiceNumber = "This field is required";
    }
    if (Object.keys(errs)?.length > 0) return setCreateErrs(errs);
    // const reqObj = {
    //   id:
    //     createValues?.type?.value === "Return on Purchase"
    //       ? createValues?.supplier?.value
    //       : createValues?.invoiceNumber?.value,
    // };
    if (createValues?.type?.value === "Return on Purchase") {
      const reqBill = (suppliers?.data ?? [])?.find(
        (pay) => pay?.supplierId === createValues?.invoiceNumber?.supplierId,
      );
      const reqSupDet = reqBill?.supplierDetails?.find(
        (suDe) => suDe?.detailId === createValues?.invoiceNumber?.detailId,
      );
      const reqTableList = reqSupDet?.supplierInvoiceDetails?.map((sil) => {
        const mrpPrice =
          Number(sil?.itemTotal ?? 0) / Number(sil?.quantity ?? 0);
        // const tax = Number(sil?.taxes ?? 0) / Number(sil?.quantity ?? 0);
        return {
          ...sil,
          total: sil?.itemTotal,
          returnQuantity: 0,
          name: sil?.tradeName,
          mrpPrice,
          tax: sil?.taxes ?? 0,
          price: mrpPrice ?? 0,
        };
      });
      const returnObj = {
        refundMethod: {
          name: "Advance Adjustment",
          value: "Advance Adjustment",
        },
        remarks: reqBill?.remarks ?? "",
        returnReason: returnReasons?.[0],
        personInCharge: null,
        invoiceNumber: createValues?.invoiceNumber,
        list: reqTableList,
        type: createValues?.type?.value,
      };
      setSelectedBill({
        ...reqBill,
        createdDate: reqSupDet?.billDate,
        invoiceNumbers: reqSupDet?.invoiceNumber,
      });
      setReturnValue(returnObj);
      setUpdateModVsble(true);
      return handleCloseCreateMod();
      // reqObj.url = `?type=supplier&invoiceNo=${createValues?.invoiceNumber?.value}`;
    }
    if (createValues?.type?.value === "Return on Sales") {
      const reqBill = (hugePayments?.data ?? [])?.find(
        (pay) => pay?.paymentId === createValues?.invoiceNumber?.paymentId,
      );
      const returnObj = {
        refundMethod: {
          name: "Advance Adjustment",
          value: "Advance Adjustment",
        },
        remarks: reqBill?.remarks ?? "",
        returnReason: returnReasons?.[0],
        personInCharge: null,
        invoiceNumber: createValues?.invoiceNumber,
        type: createValues?.type?.value,
      };
      const reqList = createValues?.invoiceNumber?.value?.includes("INVC")
        ? getTreatmentRecordBasedType(reqBill?.paymentDetails)
        : createValues?.invoiceNumber?.value?.includes("INVP")
          ? getPharmacyRecordBasedType(reqBill?.paymentDetails)
          : createValues?.invoiceNumber?.value?.includes("INVS")
            ? getPetShopRecordBasedType(reqBill?.paymentDetails)
            : [];
      returnObj.list = reqList
        ?.filter(
          (li) =>
            li?.credit === "N" &&
            li?.type?.toLowerCase() !== "consumables" &&
            li?.type?.toLowerCase() !== "administered" &&
            li?.quantity > 0 &&
            (li?.returnQuantity === 0 || !li?.returnQuantity),
        )
        ?.map((li) => ({ ...li, returnQuantity: 0 }));
      setSelectedBill(reqBill);
      setReturnValue(returnObj);
      setUpdateModVsble(true);
      return handleCloseCreateMod();
    }
    // dispatch(createBillingReturn(reqObj)).then((res) => {
    //   if (res?.payload) {
    //     if (activeTab === "Sales") getPayments();
    //     if (activeTab === "Purchase") getSupplierReturnsRecord();
    //     handleCloseCreateMod();
    //   }
    // });
  };

  const getRequiredSupplierDetails = (bil) => {
    return bil?.supplierDetails?.find((det) => det?.credit === "Y") ?? null;
  };

  const handleUpdate = (bill) => {
    setSelectedBill(bill);
    // if (bill?.creditSave === "draft") {
    const reqObj = {
      refundMethod: {
        name: "Advance Adjustment",
        value: "Advance Adjustment",
      },
      remarks: bill?.remarks ?? "",
    };
    const reqRetunReson = returnReasons?.find(
      (li) => li?.value === bill?.returnReason,
    );
    reqObj.returnReason = reqRetunReson ? reqRetunReson : returnReasons?.[0];
    if ((bill?.personInCharge ?? "")?.toString()?.length > 0) {
      const matchedUser = (clinicVets ?? [])?.find(
        (li) => li?.doctorId === bill?.personInCharge,
      );
      reqObj.personInCharge = {
        name: matchedUser?.name,
        value: matchedUser?.doctorId ?? bill?.personInCharge,
      };
    }
    // if (bill?.creditSave === "draft") {
    // if (activeTab === "Purchase") {
    //   const reqDet = getRequiredSupplierDetails(bill);
    //   if (reqDet) {
    //     reqObj.list = reqDet?.subpplierInvoiceDetails
    //       ?.filter((li) => li?.credit !== "Y")
    //       ?.map((li) => {
    //         const stck = clinicStocks?.data?.find(
    //           (stc) => stc?.stockId === li?.stockId,
    //         );
    //         const newObj = {
    //           ...li,
    //           name: li?.tradeName ?? stck?.productName,
    //           returnQuantity: 0,
    //         };
    //         const isPrev = reqDet?.subpplierInvoiceDetails?.find(
    //           (pd) => pd?.stockId === li?.stockId && pd?.credit === "Y",
    //         );
    //         if (isPrev) {
    //           newObj.returnQuantity = isPrev?.returnQuantity;
    //         }
    //         return newObj;
    //       });
    //   }
    // } else {
    reqObj.list = bill?.paymentReturnDeatils
      // bill?.paymentDetails
      ?.filter(
        (li) =>
          // li?.credit !== "Y" &&
          // (li?.type ?? "")?.toLowerCase() !== "consumables" &&
          // (li?.type ?? "")?.toLowerCase() !== "administered" &&
          li?.quantity > 0 && li?.returnQuantity > 0,
      )
      ?.map((li) => ({ ...li, oldReturnQuantity: li?.returnQuantity ?? 0 }));
    // ?.map((li) => {
    //   const newObj = { ...li, returnQuantity: 0 };
    //   const isPrev = bill?.paymentDetails?.find(
    //     (pd) => pd?.name === li?.name
    //     // && pd?.credit === "Y"
    //   );
    //   if (isPrev) {
    //     newObj.returnQuantity = isPrev?.returnQuantity;
    //   }
    //   return newObj;
    // });
    // }
    // }
    setReturnValue(reqObj);
    if (bill?.creditSave === "draft") {
      setUpdateModVsble(true);
    }
    if (bill?.creditSave !== "draft") {
      setViewModVsble(true);
    }
    // return setUpdateModVsble(true);
    // }
    // if (bill?.creditSave !== "draft") {
    //   setViewModVsble(true);
    // }
  };

  const submitReturn = (status = "") => {
    const returnList = returnValue?.list;
    // ?.filter((li) =>
    //   // Number(li?.returnQuantity) > 0 &&
    //   activeTab === "Purchase" ? li?.batchNumber?.value : true,
    // );
    if (returnList?.length === 0 || !returnList) return setListNotValid(true);
    if (returnValue?.type === "Return on Purchase") {
      const paymentDetails = returnList?.map((li, i) => {
        const unitPrice = isNaN(
          Number(Number(li?.total ?? li?.itemTotal) / Number(li?.quantity)),
        )
          ? 0
          : Number(Number(li?.total ?? li?.itemTotal) / Number(li?.quantity));
        const unitTax = isNaN(Number(Number(li?.tax) / Number(li?.quantity)))
          ? 0
          : Number(Number(li?.tax) / Number(li?.quantity));
        const reqbj = {
          unitPrice,
          unitTax,
          quantity: li?.quantity ?? 0,
          tax: Number(Number(unitTax ?? 0) * Number(li?.returnQuantity ?? 0)),
          price: li?.price,
          total: Number(
            Number(unitPrice ?? 0) * Number(li?.returnQuantity ?? 0),
          ),
          returnQuantity: Number(li?.returnQuantity),
          name: li?.name,
          paymentDetailId: li?.paymentDetailId ?? null,
          stockId: li?.stockId ?? null,
          batchId: li?.batchId ?? null,
          paymentDetailId: null,
          returnDetailId: li?.paymentDetailId ?? null,
        };
        if (li?.uomName) reqbj.uomName = li?.uomName;
        if (li?.uomId) reqbj.uomId = li?.uomId;
        if (li?.serviceId) reqbj.serviceId = li?.serviceId;
        if (li?.stockId) reqbj.stockId = li?.stockId;
        if (li?.batchId) reqbj.batchId = li?.batchId;
        if (li?.paymentDetailId) reqbj.paymentDetailId = li?.paymentDetailId;
        return reqbj;
      });

      const sumPaymentDetailsBy = (key) =>
        paymentDetails?.reduce((acc, obj) => acc + Number(obj?.[key] ?? 0), 0);
      const amountPaid = Number(
        selectedBill?.tab === "petShop"
          ? (selectedBill?.petShopAmtPaid ?? 0)
          : selectedBill?.tab === "pharmacy"
            ? (selectedBill?.pharmacyAmtPaid ?? 0)
            : (selectedBill?.amtPaid ?? 0),
      );

      const remainingItemsValue = (returnValue?.list ?? [])?.reduce(
        (acc, li) => {
          const remainingQty = Math.max(
            0,
            Number(li?.quantity ?? 0) - Number(li?.returnQuantity ?? 0),
          );
          const unitPrice = isNaN(
            Number(Number(li?.total) / Number(li?.quantity)),
          )
            ? 0
            : Number(Number(li?.total) / Number(li?.quantity));
          return acc + Number(unitPrice) * remainingQty;
        },
        0,
      );

      const refundAmount = Math.max(
        0,
        amountPaid - Number(remainingItemsValue ?? 0),
      );
      const data = {
        paymentMode: amountPaid > 0 ? returnValue?.refundMethod?.value : null,
        personInCharge: returnValue?.personInCharge?.value ?? null,
        returnReason: returnValue?.returnReason?.value,
        paymentDetails,
        creditSave: status,
        remarks: returnValue?.remarks ?? "",
        invoiceNumbers: returnValue?.invoiceNumber?.value ?? "",
        refundAmount: -Number(refundAmount),
        totalAmt: -Number(sumPaymentDetailsBy("total") ?? 0),
        totalTax: -Number(sumPaymentDetailsBy("tax") ?? 0),
      };
      if (returnValue?.type !== "Return on Purchase") data.type = "sales";
      if (returnValue?.type === "Return on Purchase") data.type = "purchase";
      dispatch(
        selectedBill?.returnId
          ? // activeTab !== "Purchase"
            //   ?
            updateReturnOnBillingItems({
              data,
              id: selectedBill?.returnId,
              // returnValue?.type === "Return on Purchase"
              //   ? returnValue?.invoiceNumber?.detailId
              //   : (selectedBill?.paymentId ??
              //     returnValue?.invoiceNumber?.paymentId ??
              //     // returnValue?.invoiceNumber?.supplierId
              //     returnValue?.invoiceNumber?.detailId),
            })
          : createReturnOnBillingItems({
              data,
              id:
                returnValue?.type === "Return on Purchase"
                  ? returnValue?.invoiceNumber?.detailId
                  : (selectedBill?.paymentId ??
                    returnValue?.invoiceNumber?.paymentId ??
                    // returnValue?.invoiceNumber?.supplierId
                    returnValue?.invoiceNumber?.detailId),
            }),
        // : updateBillingItemsReturn({
        //     data,
        //     id:
        //       activeTab === "Purchase"
        //         ? selectedBill?.supplierId
        //         : selectedBill?.paymentId,
        //   }),
      ).then((res) => {
        if (res?.payload) {
          getPayments();
          // if (activeTab === "Purchase") {
          //   getSupplierReturnsRecord();
          // } else {
          //   getPayments();
          // }
          handleCloseUpdateMod();
        }
      });
    } else {
      const returnList = returnValue?.list?.filter(
        (li) => Number(li?.returnQuantity) > 0,
      );
      if (returnList?.length === 0 || !returnList) return setListNotValid(true);
      const paymentDetails = returnList?.map((li) => {
        const unitPrice = isNaN(
          Number(Number(li?.total) / Number(li?.oldReturnQuantity)),
        )
          ? 0
          : Number(Number(li?.total) / Number(li?.oldReturnQuantity));
        const unitTax = isNaN(Number(Number(li?.tax) / Number(li?.quantity)))
          ? 0
          : Number(Number(li?.tax) / Number(li?.oldReturnQuantity));
        const reqbj = {
          unitPrice,
          unitTax,
          quantity: li?.quantity ?? 0,
          tax: Number(Number(unitTax ?? 0) * Number(li?.returnQuantity ?? 0)),
          price: li?.price,
          total: Number(
            Number(unitPrice ?? 0) * Number(li?.returnQuantity ?? 0),
          ),
          returnQuantity: Number(li?.returnQuantity),
          name: li?.name,
        };
        if (li?.uomName) reqbj.uomName = li?.uomName;
        if (li?.uomId) reqbj.uomId = li?.uomId;
        if (li?.serviceId) reqbj.serviceId = li?.serviceId;
        if (li?.stockId) reqbj.stockId = li?.stockId;
        if (li?.batchId) reqbj.batchId = li?.batchId;
        if (li?.paymentDetailId) reqbj.paymentDetailId = li?.paymentDetailId;
        return reqbj;
      });
      const sumPaymentDetailsBy = (key) =>
        paymentDetails?.reduce((acc, obj) => acc + Number(obj?.[key] ?? 0), 0);

      const amountPaid = Number(
        (selectedBill?.petShopAmtPaid ?? 0) +
          (selectedBill?.pharmacyAmtPaid ?? 0) +
          (selectedBill?.amtPaid ?? 0),
      );

      const remainingItemsValue = (returnValue?.list ?? [])?.reduce(
        (acc, li) => {
          const remainingQty = Math.max(
            0,
            Number(li?.quantity ?? 0) - Number(li?.returnQuantity ?? 0),
          );
          const unitPrice = isNaN(
            Number(Number(li?.total) / Number(li?.quantity)),
          )
            ? 0
            : Number(Number(li?.total) / Number(li?.quantity));
          return acc + Number(unitPrice) * remainingQty;
        },
        0,
      );

      const refundAmount = Math.max(
        0,
        amountPaid - Number(remainingItemsValue ?? 0),
      );

      const data = {
        paymentMode: amountPaid > 0 ? returnValue?.refundMethod?.value : null,
        personInCharge: returnValue?.personInCharge?.value ?? null,
        returnReason: returnValue?.returnReason?.value,
        paymentDetails,
        creditSave: status,
        remarks: returnValue?.remarks ?? "",
        invoiceNumbers:
          selectedBill?.invoiceNumbers ?? returnValue?.invoiceNumber?.name,
        refundAmount: -Number(refundAmount),
        totalAmt: -Number(sumPaymentDetailsBy("total") ?? 0),
        totalTax: -Number(sumPaymentDetailsBy("tax") ?? 0),
      };
      if (returnValue?.type !== "Return on Purchase") data.type = "sales";
      if (returnValue?.type === "Return on Purchase") data.type = "purchase";
      // if (returnValue?.isCancel) {
      //   if (
      //     (selectedBill?.tab ?? returnValue?.tab)?.toLowerCase() === "treatment"
      //   )
      //     data.status = "cancelled";
      //   if (
      //     (selectedBill?.tab ?? returnValue?.tab)?.toLowerCase() === "pharmacy"
      //   )
      //     data.pharmacyStatus = "cancelled";
      //   if (
      //     (selectedBill?.tab ?? returnValue?.tab)?.toLowerCase() === "petshop"
      //   )
      //     data.petShopStatus = "cancelled";
      // }
      dispatch(
        selectedBill?.returnId
          ? updateReturnOnBillingItems({ data, id: selectedBill?.returnId })
          : createReturnOnBillingItems({
              data,
              id:
                returnValue?.type === "Return on Purchase"
                  ? returnValue?.invoiceNumber?.detailId
                  : (selectedBill?.paymentId ??
                    returnValue?.invoiceNumber?.paymentId ??
                    // returnValue?.invoiceNumber?.supplierId
                    returnValue?.invoiceNumber?.detailId),
            }),
      ).then((res) => {
        if (res?.payload) {
          getPayments();
          handleCloseUpdateMod();
        }
      });
    }
  };

  const handleChangeTblValue = (name, value, ind) => {
    const reqList = returnValue?.list?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (name === "returnQuantity") {
          reqObj.returnQuantityErr =
            Number(li?.quantity) < Number(value) ? "Maximum limit reached" : "";
        }
        return reqObj;
      }
      return li;
    });
    if (listNotValid) {
      if (
        reqList?.some(
          (li) =>
            Number(li?.returnQuantity) > 0 &&
            (activeTab === "Purchase" ? li?.batchNumber?.value : true),
        )
      ) {
        setListNotValid(false);
      }
    }
    const reqValue = { ...returnValue, list: reqList };
    setReturnValue(reqValue);
  };

  const onCloseViewMod = () => {
    setViewModVsble(false);
    setSelectedBill(null);
  };

  const handlePrint = useReactToPrint({
    documentTitle: `${clinicDet?.name ?? ""}-${
      selectedBill?.invoiceNumbers ?? ""
    }`,
    removeAfterPrint: true,
  });

  const getBatchNumbersByStockId = (stockId = null) => {
    if (!stockId) return [];
    const reqPrd = clinicStocks?.find((stc) => stc?.stockId === stockId);
    if (reqPrd) {
      const reqList = reqPrd?.stockBatch?.map((btc) => ({
        name: btc?.batchNo,
        value: btc?.batchId,
      }));
      return reqList;
    }
    return [];
  };

  const ignoreKeys = ["paymentDetailId", "createdDate", "updatedDate"];

  const getUniqList = () => {
    const result = [
      ...new Map(
        (selectedBill?.paymentDetails ?? selectedBill?.paymentReturnDeatils)
          ?.filter(
            (li) =>
              // li?.credit === "Y" &&
              li?.type?.toLowerCase() !== "consumables" &&
              li?.type?.toLowerCase() !== "administered" &&
              li?.returnQuantity > 0,
          )
          ?.map((li) => {
            const reqObj = { ...li };
            if (activeTab === "Sales")
              reqObj.quantity = Number(li?.returnQuantity ?? 0);
            if (activeTab === "Purchase") {
              const reqPrice = Number(
                Number(li?.itemTotal ?? 0) / Number(li?.quantity ?? 0),
              );
              reqObj.price = reqPrice;
              reqObj.mrpPrice = reqPrice;
              reqObj.tax = Number(
                Number(li?.taxes ?? 0) / Number(li?.quantity ?? 0),
              );
              reqObj.total = Number(reqPrice) * Number(li?.returnQuantity ?? 0);
              reqObj.quantity = 0;
            }
            return reqObj;
          })
          ?.map((item) => {
            const cleaned = Object.fromEntries(
              Object.entries(item)?.filter(
                ([key]) => !ignoreKeys.includes(key),
              ),
            );
            return [JSON.stringify(cleaned), item];
          }),
      )?.values(),
    ];
    return result;
  };

  const getStockPriceByStockAndBatchId = (stockId = null, batchId = null) => {
    if (!stockId) return [];
    const reqPrd = clinicStocks?.find((stc) => stc?.stockId === stockId);
    if (reqPrd) {
      let reqBatch = null;
      if (batchId) {
        reqBatch = reqPrd?.stockBatch?.find((btc) => btc?.batchId === batchId);
        return reqBatch;
      }
      return reqPrd?.stockBatch?.[0];
    }
    return {};
  };

  const getPersonInChargeList = () => {
    return (clinicVets ?? [])
      ?.filter((li) => rolesForBilling.includes(li?.userRole))
      ?.map((li) => ({ name: li?.name, value: li?.doctorId }));
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSelectedBill(null);
  };

  const onConfirmDelete = () => {
    if (!selectedBill?.returnId) return;
    dispatch(deleteReturnPaymentById(selectedBill?.returnId)).then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        getPayments();
      }
    });
  };

  return (
    <>
      <div className="back-white pv10">
        <div className="flex-row-ali-cen w100Per ph20">
          <div className="flex-center w100Per">
            <div className="flex1-start">
              <Typography className="font-medium fs12 gray28">
                Number of count: {returnPaymentsNew?.totalRecords ?? 0}
              </Typography>
            </div>
            <div className="flex-row-ali-cen">
              <div style={{ width: "400px" }}>
                <CustomTextField
                  placeholder="Search"
                  fullWidth
                  backgroundColor={AppColors.lightBlue2}
                  value={searchValue}
                  handleChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
              <div className="ml10">
                <CustomButton
                  text="Create"
                  smallBtn
                  onClick={() => setCreateModVsble(true)}
                />
              </div>
              <div className="ml10">
                <CustomButton text="⬇" smallBtn />
              </div>
            </div>
            <div className="flex1-end">
              <div className="w70Per">
                <CustomSelect
                  list={returnTypes}
                  fullWidth
                  value={activeTab}
                  handleChange={(e) => setActiveTab(e?.target?.value)}
                />
              </div>
            </div>
          </div>
        </div>
        <Box className="ph20">
          <TableContainer sx={{ maxHeight: 480 }} className="mt10">
            <Table
              sx={{ minWidth: 200 }}
              aria-labelledby="tableTitle"
              stickyHeader
            >
              <TableHead>
                <TableRow>
                  {(activeTab === "Purchase" ? supTblHdrs : tblHdrs)?.map(
                    (hdr, i) => (
                      <TableCell
                        style={tblGrayBack}
                        className="txt-semi-bold fs12"
                        key={hdr + i}
                      >
                        <div>{tblNameExpan?.[hdr]}</div>
                      </TableCell>
                    ),
                  )}
                </TableRow>
              </TableHead>
              {getTableList()?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={12} className="text-align-center h100">
                    <div className="no-rec">No records available</div>
                  </TableCell>
                </TableRow>
              )}
              <TableBody>
                {getTableList()?.map((li, ind) => {
                  return (
                    <TableRow>
                      {(activeTab === "Purchase" ? supTblHdrs : tblHdrs)?.map(
                        (hdr, i) => {
                          return (
                            <TableCell
                              key={`${ind} + ${i} + tr`}
                              component="th"
                            >
                              <div>
                                {hdr === "date" ? (
                                  moment(new Date(li?.[hdr])).format(
                                    "DD MMM YYYY",
                                  )
                                ) : hdr === "customer" || hdr === "supplier" ? (
                                  <Custom3dotString
                                    str={li?.[hdr]}
                                    className="font-regular fs14"
                                  />
                                ) : hdr === "invoice" ? (
                                  <div
                                    className="cursor"
                                    onClick={() => handleUpdate(li)}
                                  >
                                    <Custom3dotString
                                      str={li?.[hdr]}
                                      className="font-regular fs14 blue4"
                                    />
                                  </div>
                                ) : hdr === "refundableTax" ||
                                  hdr === "returnTotal" ? (
                                  Number(li?.[hdr])?.toFixed(2)
                                ) : (
                                  li?.[hdr]
                                )}
                              </div>
                            </TableCell>
                          );
                        },
                      )}
                    </TableRow>
                  );
                })}
              </TableBody>
              {Math.ceil((returnPaymentsNew?.totalRecords ?? 0) / itemSize) >
              1 ? (
                <TableFooter>
                  <TableRow>
                    <TableCell colSpan={12}>
                      <div className="flex-end">
                        <Pagination
                          count={Math.ceil(
                            (returnPaymentsNew?.totalRecords ?? 0) / itemSize,
                          )}
                          variant="outlined"
                          color="primary"
                          page={page}
                          onChange={handleChangePage}
                        />
                      </div>
                    </TableCell>
                  </TableRow>
                </TableFooter>
              ) : null}
            </Table>
          </TableContainer>
        </Box>
      </div>

      <CustomModal
        open={createModVsble}
        onClose={handleCloseCreateMod}
        header="Stock Adjustment"
        modalWidth={30}
        rightModal
      >
        <div className="scroll-90vh">
          <Grid container spacing={2} className="ph20">
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="txt-semi-bold fs14 light-grey">
                Type <span className="red-color">*</span>
              </div>
              <CustomSelect
                list={ReturnAdjustList}
                handleChange={(e, value) => onChangeCreateValue("type", value)}
                value={createValues?.type}
                helperText={createErrs?.type}
                error={!!createErrs?.type}
                search
              />
            </Grid>
            {createValues?.type?.value === "Return on Purchase" ? (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <CustomTextField
                    fullWidth
                    search
                    value={srchSupValue}
                    placeholder="Search Supplier"
                    handleChange={(e) => setSrchSupValue(e?.target?.value)}
                    backgroundColor={AppColors.gray6}
                  />
                </Grid>
                {srchSupValue?.length > 2 && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {getFilteredSupplierList()?.length > 0 &&
                      getFilteredSupplierList()?.map((sup) => {
                        return (
                          <Grid
                            container
                            spacing={1}
                            key={sup?.supplierId}
                            className="cursor"
                            onClick={() => handleSelectedSupplier(sup)}
                          >
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <Grid container spacing={1}>
                                <Grid item xs={12}>
                                  <Card
                                    sx={{
                                      borderRadius: 1,
                                      padding: 2,
                                      borderTopColor: AppColors.appPrimary,
                                    }}
                                    className="CustomCard-back-appointment"
                                  >
                                    <div className="maint">
                                      <div className="flex-row">
                                        <Grid item>
                                          <div className="flex-row">
                                            <div className="flex-start">
                                              <div className="flex-column">
                                                <div className="flex-row">
                                                  <Typography className="mb10 font-bold fs14 capitalize">
                                                    {sup?.supplierName}
                                                  </Typography>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </Grid>
                                      </div>
                                    </div>
                                  </Card>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })}
                  </Grid>
                )}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Supplier <span className="red-color">*</span>
                  </div>
                  <CustomSelect
                    list={[]}
                    handleChange={(e, value) =>
                      onChangeCreateValue("supplier", value)
                    }
                    value={createValues?.supplier}
                    helperText={createErrs?.supplier}
                    error={!!createErrs?.supplier}
                    search
                    disabled
                  />
                </Grid>

                {createValues?.supplier?.value ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="txt-semi-bold fs14 light-grey">
                      Invoice Number <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={getSupInvoiceList()}
                      handleChange={(e, value) =>
                        onChangeCreateValue("invoiceNumber", value)
                      }
                      value={createValues?.invoiceNumber}
                      helperText={createErrs?.invoiceNumber}
                      error={!!createErrs?.invoiceNumber}
                      search
                    />
                  </Grid>
                ) : null}
              </>
            ) : null}
            {createValues?.type?.value === "Return on Sales" ? (
              <>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <CustomTextField
                    fullWidth
                    search
                    value={srchUsrValue}
                    placeholder="Search Customer"
                    handleChange={(e) => setSrchUsrValue(e?.target?.value)}
                    backgroundColor={AppColors.gray6}
                  />
                </Grid>
                {srchUsrValue?.length > 2 && (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {getFilteredUserList()?.length > 0 &&
                      getFilteredUserList()?.map((usr) => {
                        return (
                          <Grid
                            container
                            spacing={1}
                            key={usr?.id}
                            className="cursor"
                            onClick={() => handleSelectedUser(usr)}
                          >
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <Grid container spacing={1}>
                                <Grid item xs={12}>
                                  <Card
                                    sx={{
                                      borderRadius: 1,
                                      padding: 2,
                                      borderTopColor: AppColors.appPrimary,
                                    }}
                                    className="CustomCard-back-appointment"
                                  >
                                    <div className="maint">
                                      <div className="flex-row">
                                        <Grid item>
                                          <div className="flex-row">
                                            <div className="flex-start">
                                              <div className="flex-column">
                                                <div className="flex-row">
                                                  <Typography className="mb10 font-bold fs14 capitalize">
                                                    {usr?.name}
                                                  </Typography>
                                                </div>
                                                <Typography className="mb10 txt-regular card-gray-color fs12">
                                                  {usr?.email}
                                                </Typography>
                                                <Typography className="mb10 txt-regular card-gray-color fs12">
                                                  {usr?.mobile}
                                                </Typography>
                                              </div>
                                            </div>
                                          </div>
                                        </Grid>
                                      </div>
                                    </div>
                                  </Card>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        );
                      })}
                  </Grid>
                )}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="txt-semi-bold fs14 light-grey">
                    Customer <span className="red-color">*</span>
                  </div>
                  <CustomSelect
                    list={[]}
                    handleChange={(e, value) =>
                      onChangeCreateValue("customer", value)
                    }
                    value={createValues?.customer}
                    helperText={createErrs?.customer}
                    error={!!createErrs?.customer}
                    search
                    disabled
                  />
                </Grid>
                {createValues?.customer?.value ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="txt-semi-bold fs14 light-grey">
                      Invoice Number <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={getInvoiceList()}
                      handleChange={(e, value) =>
                        onChangeCreateValue("invoiceNumber", value)
                      }
                      value={createValues?.invoiceNumber}
                      helperText={createErrs?.invoiceNumber}
                      error={!!createErrs?.invoiceNumber}
                      search
                    />
                  </Grid>
                ) : null}
              </>
            ) : null}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex1-end mt10">
                <div>
                  <CustomButton text="Submit" smallBtn onClick={handleSubmit} />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>
      <CustomModal
        open={updateModVsble}
        onClose={handleCloseUpdateMod}
        header={returnValue?.type}
        modal
        modalWidth={90}
      >
        <div className="scroll-80vh">
          <div className="return-back">
            <div className="flex-row-ali-cen ph40 mv15">
              <div
                className={
                  returnValue?.type === "Return on Sales" ? "w20Per" : "w25Per"
                }
              >
                <Typography className="gray29 fs12 font-medium">
                  {returnValue?.type === "Return on Purchase"
                    ? "Supplier"
                    : "Pet"}{" "}
                  Name
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {(returnValue?.type === "Return on Purchase"
                    ? selectedBill?.supplierName
                    : selectedBill?.petName) ?? ""}
                </Typography>
              </div>
              <div
                className={
                  returnValue?.type === "Return on Sales" ? "w20Per" : "w25Per"
                }
              >
                <Typography className="gray29 fs12 font-medium">
                  {returnValue?.type === "Return on Purchase"
                    ? "Supplier GST No."
                    : "Parent Name"}
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {(returnValue?.type === "Return on Purchase"
                    ? (selectedBill?.gstNumber ?? "")
                    : selectedBill?.userName) ?? ""}
                </Typography>
              </div>
              <div
                className={
                  returnValue?.type === "Return on Sales" ? "w20Per" : "w25Per"
                }
              >
                <Typography className="gray29 fs12 font-medium">
                  Invoice number
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {selectedBill?.invoiceNumbers ?? ""}
                </Typography>
              </div>
              <div
                className={
                  returnValue?.type === "Return on Sales" ? "w20Per" : "w25Per"
                }
              >
                <Typography className="gray29 fs12 font-medium">
                  Invoice date
                </Typography>
                <Typography className="fs14 black22 txt-semi-bold">
                  {moment(new Date(selectedBill?.createdDate)).format(
                    "DD MMM YYYY",
                  )}
                </Typography>
              </div>
              {returnValue?.type === "Return on Sales" ? (
                <div className="w20Per">
                  <Typography className="gray29 fs12 font-medium">
                    Amount Received
                  </Typography>
                  <Typography className="fs14 black22 txt-semi-bold">
                    {Number(selectedBill?.amtPaid ?? 0) +
                      Number(selectedBill?.pharmacyAmtPaid ?? 0) +
                      Number(selectedBill?.petShopAmtPaid ?? 0)}
                  </Typography>
                </div>
              ) : null}
            </div>
          </div>

          <div className="flex-row-ali-cen mt20 ph10">
            <div className={activeTab === "Purchase" ? "w20Per" : "w25Per"}>
              <Typography className="txt-semi-bold fs12 blue-color">
                Service/Item Name
              </Typography>
            </div>
            {activeTab === "Purchase" ? (
              <div className="w15Per">
                <Typography className="txt-semi-bold fs12 blue-color">
                  Batch Number
                </Typography>
              </div>
            ) : null}
            <div className={activeTab === "Purchase" ? "w10Per" : "w15Per"}>
              <Typography className="txt-semi-bold fs12 blue-color">
                Available Qty
              </Typography>
            </div>
            <div className={activeTab === "Purchase" ? "w10Per" : "w15Per"}>
              <Typography className="txt-semi-bold fs12 blue-color">
                Returning Qty
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Unit Price
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Refundable Taxes
              </Typography>
            </div>
            <div className="w15Per">
              <Typography className="txt-semi-bold fs12 blue-color">
                Refund Total
              </Typography>
            </div>
          </div>
          <div className="blue-hor-split mt5" />
          {returnValue?.list?.map((li, i) => {
            const taxVal =
              Number(
                Number(li?.tax ?? 0) / Number(li?.oldReturnQuantity ?? 0),
              ) * Number(li?.returnQuantity ?? 0);

            return (
              <div className="plan-bor mt10 flex-row-ali-cen" key={`${i} li`}>
                <div
                  className="w25Per pr10"
                  // className={`${
                  //   activeTab === "Purchase" ? "w20Per" : "w25Per"
                  // } pr10`}
                >
                  <Custom3dotString
                    className="txt-regular fs12 gray30"
                    str={li?.name}
                    length={25}
                  />
                </div>
                {/* {activeTab === "Purchase" ? (
                  <div className="w15Per pr10">
                    <CustomSelect
                      list={getBatchNumbersByStockId(li?.stockId)}
                      handleChange={(e, value) =>
                        handleChangeTblValue("batchNumber", value, i)
                      }
                      value={li?.batchNumber}
                      // helperText={createErrs?.supplier}
                      // error={!!createErrs?.supplier}
                      search
                      // disabled
                    />
                  </div>
                ) : null} */}
                <div
                  className="w15Per pr10"
                  // className={`${
                  //   activeTab === "Purchase" ? "w10Per" : "w15Per"
                  // } pr10`}
                >
                  <Typography className="txt-regular fs12 gray30">
                    {li?.quantity} Nos
                  </Typography>
                </div>
                <div
                  className="w15Per pr10"
                  // className={`${
                  //   activeTab === "Purchase" ? "w10Per" : "w15Per"
                  // } pr10`}
                >
                  <CustomTextField
                    value={li?.returnQuantity}
                    error={!!li?.returnQuantityErr}
                    helperText={li?.returnQuantityErr}
                    fullWidth
                    endIcon
                    inputIcon="Nos"
                    handleChange={(e) =>
                      handleChangeTblValue(
                        "returnQuantity",
                        e?.target?.value,
                        i,
                      )
                    }
                  />
                </div>
                <div className="w15Per pr10">
                  <Typography className="txt-regular fs12 gray30">
                    Rs{" "}
                    {Number(
                      // activeTab === "Purchase"
                      //   ? getStockPriceByStockAndBatchId(
                      //       li?.stockId,
                      //       li?.batchNumber?.value ?? null,
                      //     )?.unitSellingPrice
                      //   :
                      li?.mrpPrice,
                    )?.toFixed(2)}{" "}
                  </Typography>
                </div>
                <div className="w15Per pr10">
                  <Typography className="txt-regular fs12 gray30">
                    Rs{" "}
                    {Number(
                      // activeTab === "Purchase"
                      //   ? getTaxValueByBatchAndTaxPer(
                      //       getStockPriceByStockAndBatchId(
                      //         li?.stockId,
                      //         li?.batchNumber?.value ?? null,
                      //       ),
                      //     )?.tax
                      //   :
                      taxVal,
                    ) > 0
                      ? Number(
                          // activeTab === "Purchase"
                          //   ? getTaxValueByBatchAndTaxPer(
                          //       getStockPriceByStockAndBatchId(
                          //         li?.stockId,
                          //         li?.batchNumber?.value ?? null,
                          //       ),
                          //       li?.returnQuantity,
                          //     )?.tax
                          //   :
                          taxVal,
                        )?.toFixed(2)
                      : 0}
                  </Typography>
                </div>
                <div className="w15Per">
                  <Typography className="txt-regular fs12 gray30">
                    Rs{" "}
                    {
                      // activeTab === "Purchase"
                      //   ? Number(
                      //       getTaxValueByBatchAndTaxPer(
                      //         getStockPriceByStockAndBatchId(
                      //           li?.stockId,
                      //           li?.batchNumber?.value ?? null,
                      //         ),
                      //         li?.returnQuantity,
                      //       )?.total,
                      //     )?.toFixed(2)
                      //   :
                      Number(
                        Number(li?.returnQuantity ?? 0) *
                          Number(li?.mrpPrice ?? 0),
                      )?.toFixed(2)
                    }{" "}
                  </Typography>
                </div>
              </div>
            );
          })}
          {listNotValid ? (
            <FormHelperText error className="flex-center mt10">
              Enter quantity for atleast one item
            </FormHelperText>
          ) : null}
          <div className="flex-row mt30">
            <div className="w30Per">
              <div className="flex-column">
                {/* {activeTab === "Sales" ? ( */}
                <div>
                  <CustomSelect
                    list={returnReasons}
                    value={returnValue?.returnReason}
                    handleChange={(e, value) =>
                      handleChange("returnReason", value)
                    }
                    search
                    fullWidth
                    label="Return Reason"
                    name="returnReason"
                  />
                  <div className="mt10">
                    <CustomSelect
                      list={getPersonInChargeList()}
                      value={returnValue?.personInCharge ?? null}
                      handleChange={(e, value) => {
                        handleChange("personInCharge", value);
                      }}
                      search
                      fullWidth
                      label="Person In charge"
                      name="personInCharge"
                    />
                  </div>
                  {Number(
                    (selectedBill?.petShopAmtPaid ?? 0) +
                      (selectedBill?.pharmacyAmtPaid ?? 0) +
                      (selectedBill?.amtPaid ?? 0),
                  ) > 0 ? (
                    <div className="mt10">
                      <PaymentModeDropdown
                        list={RefundTypes}
                        value={returnValue?.refundMethod}
                        onChange={(e, value) => handleChange("refundMethod", e)}
                        name="refundMethod"
                        label="Refund Method"
                      />
                    </div>
                  ) : null}
                </div>
                {/* ) : null} */}
                <div className="mt10">
                  <CustomTextField
                    value={returnValue?.remarks}
                    handleChange={(e) =>
                      handleChange("remarks", e?.target?.value)
                    }
                    fullWidth
                    label="Remarks"
                    labelTop
                    name="remarks"
                    multiline
                  />
                </div>
              </div>
            </div>
            <div className="flex1-end">
              <div className="w50Per">
                <div className="flex-column">
                  <div className="flex-row-ali-cen">
                    <div className="w60Per">
                      <Typography className="black23 font-medium fs14">
                        Refund Subtotal
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="black23 font-medium fs14">
                        Rs.{" -"}
                        {Number(
                          returnValue?.type === "Return on Purchase"
                            ? getRefundValues(returnValue?.list)?.subTotal -
                                getRefundValues(returnValue?.list)?.tax
                            : // activeTab === "Purchase"
                              //   ? getSupplierRefundValues(
                              //       returnValue?.list,
                              //       clinicStocks,
                              //     )?.subTotal
                              //   :
                              getRefundValuesNew(returnValue?.list, true)
                                ?.subTotal,
                        )?.toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="w60Per">
                      <Typography className="black23 font-medium fs14">
                        Refundable Taxes
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="black23 font-medium fs14">
                        Rs.{" -"}
                        {Number(
                          returnValue?.type === "Return on Purchase"
                            ? // activeTab === "Purchase"
                              //   ? getSupplierRefundValues(
                              //       returnValue?.list,
                              //       clinicStocks,
                              //     )?.taxes
                              //   :
                              getRefundValues(returnValue?.list)?.tax
                            : getRefundValuesNew(returnValue?.list, true)?.tax,
                        ) > 0
                          ? Number(
                              // activeTab === "Purchase"
                              //   ? getSupplierRefundValues(
                              //       returnValue?.list,
                              //       clinicStocks,
                              //     )?.taxes
                              //   :
                              returnValue?.type === "Return on Purchase"
                                ? getRefundValues(returnValue?.list)?.tax
                                : getRefundValuesNew(returnValue?.list, true)
                                    ?.tax,
                            )?.toFixed(2)
                          : 0}
                      </Typography>
                    </div>
                  </div>

                  <div className="flex-row-ali-cen ref-ttl mt30">
                    <div className="w60Per">
                      <Typography className="blue-color txt-semi-bold fs14">
                        Refund Total
                      </Typography>
                    </div>
                    <div className="w40Per">
                      <Typography className="blue-color font-bold fs14">
                        Rs.{" -"}
                        {Number(
                          returnValue?.type === "Return on Purchase"
                            ? getRefundValues(returnValue?.list)?.subTotal
                            : // activeTab === "Purchase"
                              //   ? getSupplierRefundValues(
                              //       returnValue?.list,
                              //       clinicStocks,
                              //     )?.total
                              //   :
                              getRefundValuesNew(returnValue?.list, true)
                                ?.total,
                        )?.toFixed(2)}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex1-end mt20">
            <div>
              <CustomButton
                text="Save As Draft"
                smallBtn
                onClick={() => submitReturn("draft")}
              />
            </div>
            <div className="ml10">
              <CustomButton
                text="Submit"
                smallBtn
                onClick={() => submitReturn("credit")}
              />
            </div>
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={viewModVsble}
        onClose={onCloseViewMod}
        header={returnValue?.type}
        headerShown
        modal
        modalWidth={90}
      >
        <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
          <div ref={contentToPrint} className="bg">
            <div>
              <div className="flex-row-ali-cen mv20">
                <div className="w30Per">
                  <div>
                    <div className="flex-center">
                      {clinicDet?.image ? (
                        <img
                          src={clinicDet?.image}
                          className="img-h75"
                          alt=""
                        />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {clinicDet?.name?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                    <Typography className="flex-center fs18 txt-semi-bold mt10 blue-color">
                      {clinicDet?.name ?? profile?.name ?? ""}
                    </Typography>
                  </div>
                </div>
                <div className="w40Per flex-center">
                  <div className="font-bold fs18 blue-color">CREDIT NOTE</div>
                </div>
                <div className="w30Per flex1-end">
                  <div className="flex-column">
                    <div className="font-bold fs12 blue-color">
                      Business Address:
                    </div>
                    <div className="header-right-text2">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          CLINIC TAX ID:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {clinicDet?.taxId ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="header-right-text2 ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>

              <div className="line" />

              <div className="lower-container">
                <div className="box-container">
                  <div className="flex-row-ali-cen ph20 mv15">
                    <div
                      className={activeTab === "Purchase" ? "w25Per" : "w20Per"}
                    >
                      <Typography className="gray29 fs12 font-medium">
                        {activeTab === "Purchase" ? "Supplier" : "Pet"} Name
                      </Typography>
                      <Typography className="fs14 black22 txt-semi-bold">
                        {activeTab === "Purchase"
                          ? selectedBill?.supplierName
                          : selectedBill?.petName}
                      </Typography>
                    </div>
                    <div
                      className={activeTab === "Purchase" ? "w25Per" : "w20Per"}
                    >
                      <Typography className="gray29 fs12 font-medium">
                        {activeTab === "Purchase"
                          ? "Supplier GST No."
                          : "Parent Name"}
                      </Typography>
                      <Typography className="fs14 black22 txt-semi-bold">
                        {activeTab === "Purchase"
                          ? (selectedBill?.gstNumber ?? selectedBill?.gstin)
                          : selectedBill?.userName}
                      </Typography>
                    </div>
                    <div
                      className={activeTab === "Purchase" ? "w25Per" : "w20Per"}
                    >
                      <Typography className="gray29 fs12 font-medium">
                        Invoice Number
                      </Typography>
                      <Typography className="fs14 black22 txt-semi-bold">
                        {[
                          selectedBill?.invoiceNumbers ?? "",
                          selectedBill?.treatmentInvoiceNumber ?? "",
                          selectedBill?.petShopInvoiceNumber ?? "",
                        ]
                          ?.filter(Boolean)
                          ?.join(", ")}
                      </Typography>
                    </div>
                    {activeTab !== "Purchase" ? (
                      <div
                        className={
                          activeTab === "Purchase" ? "w25Per" : "w20Per"
                        }
                      >
                        <Typography className="gray29 fs12 font-medium">
                          Reference No.
                        </Typography>
                        <Typography className="fs14 black22 txt-semi-bold">
                          {selectedBill?.referenceNo ?? ""}
                        </Typography>
                      </div>
                    ) : null}
                    <div
                      className={activeTab === "Purchase" ? "w25Per" : "w20Per"}
                    >
                      <Typography className="gray29 fs12 font-medium">
                        Return Date
                      </Typography>
                      <Typography className="fs14 black22 txt-semi-bold">
                        {moment(new Date(selectedBill?.createdDate)).format(
                          "DD MMM YYYY",
                        )}
                      </Typography>
                    </div>
                  </div>
                  {/* <div className="row-container">
                    <div>
                      <div className="colum-header">
                        {activeTab === "Purchase" ? "Supplier" : "Pet"} Name
                      </div>
                      <div className="colum-data">
                        {activeTab === "Purchase"
                          ? selectedBill?.supplierName
                          : selectedBill?.petName}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">
                        {activeTab === "Purchase"
                          ? "Supplier GST No."
                          : "Parent Name"}
                      </div>
                      <div className="colum-data capitalize">
                        {activeTab === "Purchase"
                          ? (selectedBill?.gstNumber ?? selectedBill?.gstin)
                          : selectedBill?.userName}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Invoice Number</div>
                      <div className="colum-data">
                        {[
                          selectedBill?.invoiceNumbers ?? "",
                          selectedBill?.treatmentInvoiceNumber ?? "",
                          selectedBill?.petShopInvoiceNumber ?? "",
                        ]
                          ?.filter(Boolean)
                          ?.join(", ")}
                      </div>
                    </div>
                    <div>
                      <div className="colum-header">Return Date</div>
                      <div className="colum-data">
                        {moment(new Date(selectedBill?.createdDate)).format(
                          "DD MMM YYYY",
                        )}
                      </div>
                    </div>
                  </div> */}

                  <div className="thin-line" />

                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>S.NO.</th>
                        <th>SERVICE / ITEM NAME</th>
                        <th>RETURNING QTY</th>
                        <th>UNIT PRICE</th>
                        <th>REFUNDABLE TAXES</th>
                        <th>REFUND TOTAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getUniqList()?.length > 0 &&
                        getUniqList()?.map((itm, i) => {
                          return (
                            <tr key={i}>
                              <td>{i + 1}</td>
                              <td>
                                <div className="fs12 font-bold black">
                                  {itm?.serviceId
                                    ? removeDuplicateBracketText(
                                        itm?.tradeName ?? itm?.name,
                                      )
                                    : (itm?.tradeName ?? itm?.name)}
                                  {/* {itm?.stockId ? (
                                    <div>
                                      <div className="font-medium fs10 gray4">
                                        Generic Name: {itm?.name ?? ""}
                                      </div>
                                    </div>
                                  ) : null} */}
                                </div>
                                {/* <div className="flex-column">{itm?.name}</div> */}
                              </td>
                              <td>- {itm?.returnQuantity}</td>
                              <td>
                                Rs{" "}
                                {Number(
                                  Number(itm?.mrpPrice ?? itm?.price),
                                )?.toFixed(2)}
                              </td>
                              <td>
                                {Number(itm?.tax) > 0
                                  ? `Rs -${Number(itm?.tax)?.toFixed(2)}`
                                  : "-"}
                              </td>
                              <td>Rs -{Number(itm?.total)?.toFixed(2)}</td>
                            </tr>
                          );
                        })}

                      <tr>
                        <td colSpan="12">
                          <hr className="thin-line2" />
                        </td>
                      </tr>
                      <tr>
                        <td colSpan="12">
                          <div className="flex-row-between">
                            <div className="flex1-end">
                              <div className="w35Per pr10">
                                <div className="flex-column w100Per">
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="black22 fs14 font-medium">
                                        Refund Subtotal
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="black22 fs14 font-medium">
                                        Rs -
                                        {Number(
                                          activeTab === "Purchase"
                                            ? Number(
                                                getRefundValues(getUniqList())
                                                  ?.subTotal -
                                                  getRefundValues(getUniqList())
                                                    ?.tax,
                                              )
                                            : getRefundValuesNew(getUniqList())
                                                ?.subTotal,
                                        )?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="black22 fs14 font-medium">
                                        Refundable Taxes
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="black22 fs14 font-medium">
                                        Rs -
                                        {Number(
                                          getRefundValuesNew(getUniqList())
                                            ?.tax,
                                        )?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="thin-line2 mv5" />
                                  <div className="flex-row-ali-cen mv5">
                                    <div className="w60Per">
                                      <div className="font-bold fs14 black22">
                                        Refund Total
                                      </div>
                                    </div>
                                    <div className="w40Per flex-end">
                                      <div className="font-bold fs14 black22">
                                        Rs -
                                        {Number(
                                          activeTab === "Purchase"
                                            ? getRefundValues(getUniqList())
                                                ?.subTotal
                                            : getRefundValuesNew(getUniqList())
                                                ?.total,
                                        )?.toFixed(2)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <div className="mb20" />
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            className="back-white"
          >
            <div className="flex-end">
              <div className="mr20 mv20">
                <CustomButton
                  text="Print"
                  onClick={() =>
                    handlePrint(null, () => contentToPrint.current)
                  }
                  smallBtn
                />
              </div>
            </div>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the item?
        </Typography>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-center mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                smallBtn
                onClick={onConfirmDelete}
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Returns;
